export const CUSTOMER_CONST = {
CASH_CUSTOMER:2001
}